import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { ingestAlerts, pollingInterval } = formData;
  const handleSubmit = () => {
    if (pollingInterval.value >= 1) {
      setFormError(null);
      onSubmit();
    } else {
      setFormError({
        full_message: "Please provide valid polling interval",
        nice_message: "Minimum allowable polling interval is 1 minutes."
      });
    }
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Proceed",
      title: "",
      error: formError,
      disabled: !!formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "ingestAlerts",
        type: "checkbox",
        value: "ingest-alerts",
        defaultChecked: ingestAlerts == null ? void 0 : ingestAlerts.value,
        onChange,
        label: "Ingest Alerts",
        help: "Ingest Sophos Alerts in addition to Events."
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        name: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: "Determines how often (in minutes) the input will check for new data from Sophos Central. The smallest allowable interval is 5 minutes.",
        label: "Polling Interval"
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  );
};
export default StepSubscribe;
